<!-- Team component -->
<script>
  import { Col, Row, Container } from "sveltestrap";
  import { scrollto } from "svelte-scrollto";
  import { t, locale, locales } from "../Services/i18n";
  $: yearsOfExperience = Math.abs(new Date().getFullYear() - 2005)
</script>

<!--START PROCESS-->
<section>
  <Container>
    <Row class="mt-5">
      <Col lg="4" class="plan-line">
        <div class="text-center process-box">
          <i class="pe-7s-call" />
          <h4 class="pt-3">{$t("home.freequote")}</h4>
        </div>
      </Col>      
      <Col lg="4" class="plan-line">
        <div class="text-center process-box">
          <i class="pe-7s-global" />
          <h4 class="pt-3">{$t("home.bilingual")}</h4>
        </div>
      </Col>
      <Col lg="4">
        <div class="text-center process-box">
          <i class="pe-7s-culture" />
          <h4 class="pt-3">{$t("home.experience", {yearsOfExperience})}</h4>
        </div>
      </Col>
    </Row>
  </Container>
</section>
<!--END PROCESS-->

